/**
 * The video a playlist should open on: the first one not yet watched, or its
 * first video once everything has been seen. Shared by every playlist-change
 * trigger on the content page (the panel's playlist selector and the
 * next-playlist card) so they all land in the same place.
 */
export function getPlaylistEntryContent(playlist) {
    const contents = playlist?.contents ?? [];
    return contents.find((content) => !content.watched) ?? contents[0] ?? null;
}
